import {
  BrowserModule,
  BrowserTransferStateModule,
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ApiHelper } from '../core/services/apiHelper';
import { CoreModule } from '../core/core.module';
import { GlobalErrorHandler } from '../core/services/errorHandler/GlobalErrorHandler';
import { ErrorDialogModule } from './shared/errorDialog/errorDialog.module';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ApiInterceptorService } from '../core/services/api-interceptor.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { SignUpAddressModule } from './sign-up/become-a-captain/sign-up-address/sign-up-address.module';
import { SignUpAvailabilityModule } from './sign-up/become-a-captain/sign-up-availability/sign-up-availability.module';
import { SignUpDescriptionModule } from './sign-up/become-a-captain/sign-up-description/sign-up-description.module';
import { SignUpProfilePhotoModule } from './sign-up/profile-photo/sign-up-profile-photo.module';
import { SignInNeededModule } from './public/sign-in-needed/sign-in-needed.module';
import { FourOhFourModule } from './public/four-oh-four/four-oh-four.module';
import { CaptainInfoModule } from './public/all-for-hire/captain-for-hire/captain-info/captain-info.module';
import { CaptainForHireModule } from './public/all-for-hire/captain-for-hire/captain-for-hire.module';
import { BoatOwnerSignupModule } from './sign-up/boat-owner/boat-owner.module';
import { OwnerSignUpAddressModule } from './sign-up/boat-owner/sign-up-address/sign-up-address.module';
import { AppBuflowMapModule } from './shared/app-buyflow-map/app-buyflow-map.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { ProgressSpinnerModule } from './shared/progress-spinner-overlay/progress-spinner-overlay.module';
import { AppOverlayModule } from './shared/progress-spinner-overlay/overlay.module';
import { ProgressSpinnerComponent } from './shared/progress-spinner-overlay/progress-spinner-overlay.component';
import { VesselTotalPriceDialogModule } from './shared/public-components/carousel-vessel-card/vessel-total-price-dialog/vessel-total-price-dialog.module';
import { MatCardModule } from '@angular/material/card';
import { CustomerAccountDialogService } from './shared/dialogs/customer-account-dialog/customer-account-dialog-service';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { CustomerAccountDialogModule } from './shared/dialogs/customer-account-dialog/customer-account-dialog.module';
import { AgGridModule } from 'ag-grid-angular';
import { ListGridComponent } from './shared/listGrid/listGrid.component';
import { EditButtonComponent } from './shared/listGrid/editButton/editButton.component';
import { ApproveButtonComponent } from './shared/listGrid/approveButton/approveButton.component';
import { RejectButtonComponent } from './shared/listGrid/rejectButton/rejectButton.component';
import { ViewButtonComponent } from './shared/listGrid/viewButton/viewButton.component';
import { ApproveRejectButtonComponent } from './shared/listGrid/approveRejectButton/approve-reject-button.component';
import { DownloadButtonComponent } from './shared/listGrid/downloadButton/downloadButton.component';
import { FileOpenButtonComponent } from './shared/listGrid/fileOpenButton/fileOpenButton.component';
import { MatButtonModule } from '@angular/material/button';
import { AffiliateBannerModule } from './affiliate/affiliate-banner/affiliate-banner.module';
import { PendingChangesGuard } from '../core/services/pending-changes-guard';
import { UnsavedChangesDialogService } from './shared/dialogs/unsaved-changes/unsaved-changes-dialog-service';
import { NameEditButtonComponent } from './portal/profile/captain/boatyard/form/services-and-pricing/line-item-actions/nameEditButton/nameEditButton.component';
import { DeleteButtonComponent } from './portal/profile/captain/boatyard/form/services-and-pricing/line-item-actions/deleteButton/deleteButton.component';
import { CustomPriceComponent } from './portal/profile/captain/boatyard/form/services-and-pricing/line-item-actions/customPrice/customPrice.component';
import { hasSplitsButtonComponent } from './portal/profile/captain/boatyard/form/services-and-pricing/line-item-actions/hasSplitsButton/nameEditButton.component';
import { AffiliateLinkCopyModule } from './affiliate/affiliate-link-copy/affiliate-link-copy.module';
import { BuyflowRequestFormFieldDialogModule } from './shared/dialogs/buyflow-request-form-field-dialog/buyflow-request-form-field-dialog.module';
import { PostRendererModule } from './post-renderer/post-renderer.module';
import { AuthGuard } from '../core/services/authGuard';
import { RoleGuard } from '../core/services/roleGuard';
import { NavigationModule } from './shared/navigation/navigation.module';

@NgModule({
  declarations: [
    AppComponent,
    // AppSnackComponent,
  ],
  imports: [
    SignUpAddressModule,
    SignUpAvailabilityModule,
    SignUpDescriptionModule,
    SignUpProfilePhotoModule,
    SignInNeededModule,
    BoatOwnerSignupModule,
    OwnerSignUpAddressModule,
    CaptainForHireModule,
    CaptainInfoModule,
    AppBuflowMapModule,

    // seems like we need
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ErrorDialogModule,
    FlexLayoutModule,
    MatMenuModule,
    MatMomentDateModule,
    BrowserModule.withServerTransition({
      appId: 'anchor-client',
    }),
    BrowserTransferStateModule,
    TransferHttpCacheModule,
    AppOverlayModule,
    ProgressSpinnerModule,
    VesselTotalPriceDialogModule,
    BuyflowRequestFormFieldDialogModule,
    MatCardModule,
    MatIconModule,
    MatToolbarModule,
    MatListModule,
    MatSidenavModule,
    CustomerAccountDialogModule,
    MatButtonModule,
    AgGridModule.withComponents([
      ListGridComponent,
      EditButtonComponent,
      ApproveButtonComponent,
      RejectButtonComponent,
      ViewButtonComponent,
      ApproveRejectButtonComponent,
      DownloadButtonComponent,
      FileOpenButtonComponent,
      NameEditButtonComponent,
      hasSplitsButtonComponent,
      DeleteButtonComponent,
      CustomPriceComponent,
    ]),
    AffiliateBannerModule,
    AffiliateLinkCopyModule,
    NavigationModule,

    // may can optimize
    CoreModule,

    // seems like we need
    // MatButtonModule,
    PostRendererModule,

    // 404 module must be last to catch not found routes
    FourOhFourModule,
  ],
  providers: [
    AuthGuard,
    RoleGuard,
    CustomerAccountDialogService,
    ApiHelper,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    DatePipe,
    CurrencyPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptorService,
      multi: true,
    },
    MatSnackBarModule,
    PendingChangesGuard,
    UnsavedChangesDialogService,
  ],
  entryComponents: [
    // AppSnackComponent,
    ProgressSpinnerComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
